<template>
  <v-card class="ui-module-card" color="primary">
    <v-card-title>
      <div class="text-h5 font-weight-bold mb-4">Desarrollo del elemento</div>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="!loading">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon color="secondary" @click="refrescarDatos" :loading="loading" v-bind="attrs" v-on="on">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <span>Refrescar información</span>
      </v-tooltip>
      <v-tabs v-if="!loading" v-model="selectedTab" color="secondary" fixed-tabs>
        <v-tab class="font-weight-bold">Evaluaciones <br />médicas</v-tab>
        <v-tab class="font-weight-bold"
          >Resultados<br />consulta<br />
          previa</v-tab
        >
        <v-tab class="font-weight-bold" v-if="perfil !== PERFILES['Enlace C3']">Biométricos</v-tab>
        <v-tab v-if="estatus == 1" class="font-weight-bold">Cursos</v-tab>
        <v-tab v-if="estatus == 1" class="font-weight-bold">Armas<br />asignadas</v-tab>
        <v-tab v-if="estatus == 1" class="font-weight-bold">Equipamiento</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text>
      <v-container v-if="loading" fluid>
        <v-row align="center" justify="center" style="min-height: 300px">
          <v-col cols="12" align="center">
            <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
            <div class="text-h6 mt-4">Cargando información del elemento...</div>
          </v-col>
        </v-row>
      </v-container>
      <v-tabs-items v-else v-model="selectedTab" class="transparent">
        <v-tab-item key="1">
          <v-container>
            <v-row v-if="evaluaciones.length > 0">
              <v-col cols="4" v-for="evaluacionMedica in evaluaciones" :key="evaluacionMedica.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="evaluacionMedica.fechaAplicacion"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de aplicación"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <div class="text-caption">Resultados</div>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Clínica</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.clinica == 1" color="success">mdi-check</v-icon>
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Acondicionamiento físico</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.acondicionamientoFisico == 1" color="success"
                            >mdi-check</v-icon
                          >
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Psicológica</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.psicologica == 1" color="success">mdi-check</v-icon>
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                        <v-col cols="12">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col cols="10">
                          <div class="text-subtitle-2 font-weight-bold">Resultado</div>
                        </v-col>
                        <v-col cols="2">
                          <v-icon v-if="evaluacionMedica.resultado == 1" color="success">mdi-check</v-icon>
                          <v-icon v-else color="error">mdi-close-circle</v-icon>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">Este personal no cuenta con evaluaciones médicas registradas</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="2">
          <v-container>
            <v-row v-if="dictamenes && dictamenes.length > 0">
              <v-col cols="4" v-for="dictamen in dictamenes" :key="dictamen.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="dictamen.fecha"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de realizacion"
                          ></v-text-field>
                          <v-text-field
                            :value="dictamen.afis"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="AFIS"
                          ></v-text-field>
                          <v-text-field
                            :value="dictamen.suic"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="SUIC"
                          ></v-text-field>
                          <v-text-field
                            :value="dictamen.rnsp"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="RNSP"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" align="center" v-if="perfil === PERFILES['Personal/Site']">
                          <div class="text-caption font-weight-bold">Resultado en consulta previa</div>
                          <div class="text-subtitle-2">
                            {{ dictamen.resultadoConsultaPrevia }}
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <v-alert type="success" v-if="dictamen.fk_idCatAlerta == 1"
                            >No se encontró incidente alguno</v-alert
                          >
                          <v-alert type="warning" class="black--text" v-if="dictamen.fk_idCatAlerta == 2"
                            >Se encontró incidente menor</v-alert
                          >
                          <v-alert type="error" v-if="dictamen.fk_idCatAlerta == 3"
                            >Se encontró incidente mayor</v-alert
                          >
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text-h6">No se ha hecho la consulta previa de personal</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="3">
          <v-container>
            <v-row v-if="biometricos.length > 0">
              <v-col cols="4" v-for="biometrico in biometricos" :key="biometrico.id" class="d-flex">
                <v-card color="primary" class="ui-module-card d-flex flex-column" style="width: 100%">
                  <v-card-title class="justify-center d-block" align="center">
                    <v-icon size="60" color="secondary" v-if="biometrico.TipoBiometrico.id == 1"
                      >mdi-fingerprint</v-icon
                    >
                    <v-icon size="60" color="secondary" v-else-if="biometrico.TipoBiometrico.id == 2"
                      >mdi-microphone</v-icon
                    >
                    <v-icon size="60" color="secondary" v-else>mdi-camera</v-icon>
                    <div class="font-weight-bold text-h6 d-block">{{ biometrico.TipoBiometrico.title }}</div>
                  </v-card-title>
                  <v-card-text class="flex-grow-1">
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="biometrico.fechaRealizacion"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de captura"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <audio-player-card
                            v-if="biometrico.TipoBiometrico.id == 2"
                            :src="biometrico.URL"
                            :filename="biometrico.nombre"
                          />
                          <v-img
                            v-else-if="getDocumentType(biometrico.nombre) == 'img'"
                            :src="biometrico.URL"
                            contain
                          ></v-img>
                          <embed
                            v-else-if="getDocumentType(biometrico.nombre) == 'pdf'"
                            width="100%"
                            class="pdf"
                            name="plugin"
                            :src="biometrico.URL + '#toolbar=0&navpanes=0&scrollbar=0'"
                            type="application/pdf"
                          />
                        </v-col>
                        <v-col cols="12" align="center">
                          <div class="text-caption font-weight-bold">Observaciones</div>
                          <div v-if="biometrico.observaciones && biometrico.observaciones.length > 0" class="text-subtitle-2">
                            {{ biometrico.observaciones }}
                          </div>
                          <div v-else class="text-subtitle-2">Ninguna</div>
                        </v-col>
                        <v-col cols="12" align="center" v-if="biometrico.URL && biometrico.TipoBiometrico.id !== 2">
                          <v-btn color="secondary" @click="download(biometrico.URL)">Descargar</v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">
                  Este personal no cuenta con captura de biométricos registrados
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="4">
          <v-container>
            <v-row v-if="cursos.length > 0">
              <v-col cols="4" v-for="cursoPersonal in cursos" :key="cursoPersonal.id">
                <CursoRealizadoCard :cursoPersonal="cursoPersonal" />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">Este personal no cuenta con cursos registrados</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="6">
          <v-container>
            <v-row v-if="armas.length > 0">
              <v-col cols="4" v-for="armaPersonal in armas" :key="armaPersonal.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-title class="font-weight-bold justify-center">{{
                    armaPersonal.Arma.CatClase.clase
                  }}</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Número de inventario</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.noEconomico }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Matrícula</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.matricula }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Modelo</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.CatModelo.modelo }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Calibre</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.CatCalibre.title }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Estatus</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.CatEstatus.title }}
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="text-subtitle-2 font-weight-bold">Armero</div>
                        </v-col>
                        <v-col cols="6" align="right">
                          <div class="text-subtitle-2">
                            {{ armaPersonal.Arma.armeros }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">Este personal no cuenta con armas asignadas</div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="7">
          <v-container>
            <v-row v-if="equipamiento.length > 0">
              <v-col cols="4" v-for="equipamiento in equipamiento" :key="equipamiento.id">
                <v-card color="primary" class="ui-module-card">
                  <v-card-title class="font-weight-bold justify-center">Asignación de equipamiento</v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            :value="equipamiento.fechaAsignacion"
                            rounded
                            readonly
                            filled
                            dense
                            background-color="transparent"
                            color="secondary"
                            label="Fecha de asignación"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-list color="primary">
                            <v-subheader class="font-weight-black">Equipo asignado:</v-subheader>
                            <v-list-item v-for="equipo in equipamiento.equipoAsignado" :key="equipo.id">
                              <v-list-item-content>
                                <v-list-item-subtitle>{{
                                  equipo.Equipo.CatItem.CatTipoItem.title
                                }}</v-list-item-subtitle>
                                <v-list-item-title class="font-weight-bold">{{
                                  equipo.Equipo.CatItem.item
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{ equipo.Equipo.numero }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" align="center">
                <div class="text--secondary text-h6">
                  Este personal no cuenta con asignaciones de equipamiento registradas
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { PERFILES } from '@/perfiles.js'
import CursoRealizadoCard from '../profesionalizacion/CursoRealizadoCard.vue'
import AudioPlayerCard from './AudioPlayerCard.vue'

export default {
  components: {
    CursoRealizadoCard,
    AudioPlayerCard,
  },

  props: {
    estatus: {
      type: Number,
    },

    idPersonal: {
      type: Number,
      required: true,
    },
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),
    ...mapGetters('evaluacionMedica', { evaluaciones: 'getEvaluacionMedica' }),
    ...mapGetters('dictamenPersonal', { dictamenes: 'getDictamenPersonal' }),
    ...mapGetters('biometrico', { biometricos: 'getBiometricosPersonal' }),
    ...mapGetters('cursoAsignado', { cursos: 'getCursosAsignadosPersonal' }),
    ...mapGetters('armaPersonal', { armas: 'getArmasPersonal' }),
    ...mapGetters('asignacionEquipo', { equipamiento: 'getAsignacionesEquipo' }),

  },

  data() {
    return {
      selectedTab: null,
      loading: false,
      PERFILES,
    }
  },

  async mounted() {
    if (this.idPersonal) {
      await this.cargarDatos()
    }
  },

  methods: {
    ...mapActions('evaluacionMedica', ['fetchEvaluacionMedicaByPersonal']),
    ...mapActions('dictamenPersonal', ['fetchDictamenPersonal']),
    ...mapActions('biometrico', ['fetchBiometricosPersonal']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignadosByPersonal']),
    ...mapActions('armaPersonal', ['fetchArmasPersonal']),
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),

    async cargarDatos() {
      this.loading = true
      try {
        await Promise.all([
          this.fetchEvaluacionMedicaByPersonal(this.idPersonal),
          this.fetchDictamenPersonal(this.idPersonal),
          this.fetchBiometricosPersonal(this.idPersonal),
          this.fetchCursosAsignadosByPersonal(this.idPersonal),
          this.fetchArmasPersonal(this.idPersonal),
          this.fetchAsignacionEquipoByPersonal(this.idPersonal),
        ])
      } catch (error) {
        console.error('Error cargando datos del desarrollo del elemento:', error)
      } finally {
        this.loading = false
      }
    },

    async refrescarDatos() {
      await this.cargarDatos()
    },

    download(url) {
      window.open(url, '_blank')
    },

    getDocumentType(filename) {
      const extension = filename.split('.').pop().toLowerCase()
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension)) {
        return 'img'
      } else if (extension === 'pdf') {
        return 'pdf'
      }
      return 'unknown'
    },
  },
}
</script>

<style scoped>
/* ── Inputs (v-text-field readonly de cada tab) ── */
::v-deep .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.45) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
  background: rgba(16, 16, 30, 0.5) !important;
}

::v-deep .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep input {
  color: #e0e0e0 !important;
}

::v-deep .v-label,
::v-deep .v-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.75) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

/* ── Cards internas de cada tab ── */
::v-deep .ui-module-card {
  background: rgba(26, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 16px !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-card:hover {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  box-shadow: 0 8px 32px rgba(var(--v-secondary-base-rgb), 0.2) !important;
  transform: translateY(-2px);
}

/* ── Tabs ── */
::v-deep .v-tab {
  color: rgba(224, 224, 224, 0.7) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .v-tab:hover {
  color: var(--v-secondary-base) !important;
  background: rgba(var(--v-secondary-base-rgb), 0.08);
}

::v-deep .v-tab--active {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
}

::v-deep .v-tabs-slider {
  background: var(--v-secondary-base) !important;
  height: 3px !important;
  border-radius: 3px 3px 0 0;
  box-shadow: 0 2px 8px rgba(var(--v-secondary-base-rgb), 0.5);
}

::v-deep .v-tabs-items {
  background: transparent !important;
}

/* ── Botones ── */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* ── Tooltips ── */
::v-deep .v-tooltip__content {
  background: rgba(16, 16, 30, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* ── Dividers ── */
::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

/* ── Títulos y textos ── */
.text-h5,
.text-h6 {
  color: #ffffff !important;
}

::v-deep .text-subtitle-2 {
  color: #e0e0e0 !important;
}

::v-deep .text--secondary {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* ── Listas (equipamiento) ── */
::v-deep .v-list {
  background: transparent !important;
}

::v-deep .v-subheader {
  color: var(--v-secondary-base) !important;
}
</style>
